import { render, staticRenderFns } from "./BlockOpgaveFormulier.vue?vue&type=template&id=7c25310a&"
import script from "./BlockOpgaveFormulier.vue?vue&type=script&lang=js&"
export * from "./BlockOpgaveFormulier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports